/**
 * ESS Climate Intelligence — self-hosted visitor tracking.
 * Fires fire-and-forget beacons to the backend; never blocks rendering and
 * never throws into the caller. session_id lives in sessionStorage only —
 * it resets per tab, it is not a persistent tracking cookie.
 */

const SESSION_KEY = 'ess_session_id';

function _getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null; // private browsing / storage blocked — tracking still works, just can't dedupe by session
  }
}

function _send(payload) {
  try {
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon('/api/track', blob);
    } else {
      fetch('/api/track', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true })
        .catch(() => {});
    }
  } catch {
    // tracking must never break the page
  }
}

export function trackPageview({ region } = {}) {
  _send({
    path: location.pathname,
    referrer: document.referrer || null,
    region: region || null,
    event_type: 'pageview',
    session_id: _getSessionId(),
  });
}

export function trackRegionChange(regionKey) {
  _send({
    path: location.pathname,
    referrer: document.referrer || null,
    region: regionKey || null,
    event_type: 'region_change',
    session_id: _getSessionId(),
  });
}
